
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/consent",
      function () {
        return require("private-next-pages/docs/api/consent.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/consent"])
      });
    }
  